/** biome-ignore-all lint/a11y/noAutofocus: we want to be able to control autofocus programmatically */
import cx from 'classnames';
import {InputWrapper} from './InputWrapper';

const onKeyPressNumber = (e) => {
  if (!/[0-9.]/.test(e.key)) {
    e.preventDefault();
  }
};

export const InputNumber = ({
  'aria-label': ariaLabel,
  'data-qa-id': qaId,
  'data-qa-value': qaValue,
  variant = null,
  live = false,
  pristine = false,
  disabled,
  popOverComponent,
  tooltipContent,
  tooltipComponent,
  label,
  required,
  className,
  id,
  showOptionalLabel,
  overlayClassName,
  startAdornment,
  endAdornment,
  error,
  value,
  success,
  translucent,
  onChange,
  onFocus,
  onBlur,
  onKeyPress,
  onKeyDown,
  onInput,
  onPaste,
  placeholder,
  inputClassName,
  maxLength,
  autoComplete,
  pattern,
  autoFocus,
  readonly,
  counter,
  min,
  max,
  hideCounterArrows,
  style,
  name,
  tabIndex,
  ref,
}) => {
  return (
    <InputWrapper
      data-qa-id={qaId}
      type="number"
      {...{
        live,
        pristine,
        popOverComponent,
        tooltipContent,
        tooltipComponent,
        label,
        required,
        className,
        id,
        showOptionalLabel,
        overlayClassName,
        startAdornment,
        endAdornment,
        error,
        value,
        success,
        translucent,
      }}
    >
      <input
        type="number"
        className={cx({
          'input-counter': !counter,
          'input-text': counter,
          filled: value,
          error: error,
          'with-end-adornment': endAdornment,
          'with-start-adornment': startAdornment,
          translucent: translucent,
          [inputClassName]: !!inputClassName,
          live,
          [variant]: !!variant,
          'hide-arrows': !!hideCounterArrows,
        })}
        id={id}
        data-qa-id={qaId}
        data-qa-value={qaValue}
        value={value ? Number(value).toString() : ''}
        style={style}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onPaste={onPaste}
        onKeyDown={onKeyDown}
        onInput={onInput}
        name={name}
        placeholder={placeholder}
        ref={ref}
        disabled={!!disabled}
        maxLength={maxLength}
        autoComplete={autoComplete}
        pattern={pattern}
        autoFocus={autoFocus}
        onKeyPress={onKeyPress || onKeyPressNumber}
        readOnly={readonly}
        aria-label={ariaLabel}
        min={min}
        max={max}
        tabIndex={tabIndex}
      />
    </InputWrapper>
  );
};
